module.exports = __webpack_public_path__ + "img/gerd.dfe39cb7.jpg";